(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["control-v2-reservation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('control-v2-reservation')) {
    customElements.define('control-v2-reservation', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const form = this.querySelector('form');
        const button = form.querySelector('button[type=submit]');
        const error = this.querySelector('[data-reservation-error]');
        this.addEventListener('change', event => {
          if (!event.target.matches('[data-finish]')) return;
          const finish = event.target.dataset.finish;
          this.querySelectorAll('[data-finish-description]').forEach(node => { node.hidden = node.dataset.finishDescription !== finish; });
          document.querySelectorAll(`[data-control-section="${this.dataset.section}"][data-gallery-finish]`).forEach(node => { node.hidden = node.dataset.galleryFinish !== finish; });
        });
        form.addEventListener('submit', async event => {
          event.preventDefault();
          if (this.submitting || !form.reportValidity()) return;
          this.submitting = true;
          button.disabled = true;
          error.hidden = true;
          try {
            const data = new FormData(form);
            if (!['Polished Silver', 'Matte Polished Silver'].includes(data.get('properties[Finish]'))) throw new Error(this.dataset.finishMessage);
            data.set('quantity', '1');
            const root = window.Shopify.routes.root;
            const cartResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
            if (!cartResponse.ok) throw new Error(this.dataset.limitMessage);
            const cart = await cartResponse.json();
            if (cart.items.some(item => String(item.product_id) === this.dataset.productId && item.quantity > 0)) throw new Error(this.dataset.limitMessage);
            const response = await fetch(root + 'cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || result.message);
            window.location.assign(this.dataset.cartUrl);
          } catch (failure) {
            error.textContent = failure.message;
            error.hidden = false;
            button.disabled = false;
          } finally {
            this.submitting = false;
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
